import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "aria-label", "fill", "stroke", "stroke-width", "stroke-linecap", "stroke-linejoin"]

import { computed, defineComponent, h } from "vue";

interface Props {
  name: string;
  size?: number | string;
  className?: string;
  ariaLabel?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
    name: {},
    size: { default: 24 },
    className: { default: "" },
    ariaLabel: { default: "" }
  },
  setup(__props: any) {

const props = __props;

// BaseIcon definitions - add new icons here
const iconDefinitions = {
  "arrow-left-circle": () => [
    h("circle", { cx: "12", cy: "12", r: "10" }),
    h("polyline", { points: "12 8 8 12 12 16" }),
    h("line", { x1: "16", y1: "12", x2: "8", y2: "12" }),
  ],
  "google-drive": () => [
    h("path", {
      d: "m1.51 15.36 0.88 1.53c0.18 0.32 0.45 0.57 0.76 0.76l3.16-5.47h-6.33c0 0.36 0.09 0.71 0.28 1.03z",
      fill: "#0066da",
    }),
    h("path", {
      d: "m10.04 5.75-3.16-5.47c-0.31 0.18-0.57 0.44-0.76 0.76l-5.84 10.13a2.08 2.08 0 0 0 -0.28 1.03h6.33z",
      fill: "#00ac47",
    }),
    h("path", {
      d: "m16.91 17.66c0.31-0.18 0.57-0.44 0.76-0.76l0.37-0.63 1.76-3.05c0.18-0.32 0.28-0.68 0.28-1.03h-6.33l1.35 2.65z",
      fill: "#ea4335",
    }),
    h("path", {
      d: "m10.04 5.75 3.16-5.47c-0.31-0.18-0.67-0.28-1.03-0.28h-4.26c-0.37 0-0.72 0.1-1.03 0.28z",
      fill: "#00832d",
    }),
    h("path", {
      d: "m13.75 12.2h-7.42l-3.16 5.47c0.31 0.18 0.67 0.28 1.03 0.28h11.68c0.37 0 0.72-0.1 1.03-0.28z",
      fill: "#2684fc",
    }),
    h("path", {
      d: "m16.85 6.1-2.92-5.06c-0.18-0.32-0.45-0.57-0.76-0.76l-3.16 5.47 3.71 6.44h6.31c0-0.36-0.09-0.71-0.28-1.03z",
      fill: "#ffba00",
    }),
  ],
  edit: () => [
    h("path", {
      d: "M22.8 1.1c-1.5-1.5-4-1.5-5.5 0L0.8 16.8c0 0 0 0 0 0c0 0 0 0 0 0c0 0 0 0.1 0 0.1c0 0 0 0 0 0c0 0 0 0 0 0L0 23.4c0 0 0 0 0 0.1c0 0 0 0 0 0c0 0 0 0.1 0 0.1c0 0 0 0 0 0c0 0 0 0.1 0.1 0.1c0 0 0.1 0.1 0.1 0.1c0 0 0.1 0 0.2 0c0 0 0.1 0 0.1 0l6.5-1.5c0 0 0 0 0 0c0 0 0 0 0 0c0 0 0 0 0.1 0c0 0 0 0 0 0c0 0 0 0 0 0l15.7-15.7C24.3 5.2 24.3 2.6 22.8 1.1z M22.2 1.7c1.1 1.1 1.2 2.8 0.3 4l-4.2-4.2C19.4 0.6 21.1 0.7 22.2 1.7z M20.1 8.2l-4.3-4.3l0.6-0.6l4.3 4.3L20.1 8.2z M2.2 21.8c-0.2-0.2-0.4-0.2-0.6 0l-0.3 0.3l1.1-4.6l1.9-0.2l-0.3 2.2c0 0 0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0.1c0 0 0 0 0 0.1c0 0 0 0 0 0c0 0 0 0 0.1 0c0 0 0 0 0 0c0 0 0 0 0.1 0c0 0 0 0 0 0c0 0 0 0 0 0h0h0h0h0c0 0 0 0 0 0l2.2-0.3l-0.2 1.9L1.8 22.8l0.3-0.3C2.3 22.3 2.3 22 2.2 21.8z M7.6 19.4l9.7-9.7c0.2-0.2 0.2-0.4 0-0.6c-0.2-0.2-0.4-0.2-0.6 0L7 18.8l-2.1 0.2l0.2-2.1l9.7-9.7c0.2-0.2 0.2-0.4 0-0.6c-0.2-0.2-0.4-0.2-0.6 0L4.5 16.3l-1.4 0.2l12-12l4.3 4.3L7.5 20.8L7.6 19.4z M21.3 7l-4.3-4.3l0.6-0.6l4.3 4.3L21.3 7z",
      fill: "currentColor",
    }),
  ],
  // Add more icons here as needed
  // "close": () => [
  //   h("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
  //   h("line", { x1: "6", y1: "6", x2: "18", y2: "18" }),
  // ],
};

const viewBox = computed(() => {
  // Special viewBox for specific icons
  if (props.name === "google-drive") {
    return "0 0 20 18";
  }
  if (props.name === "edit") {
    return "0 0 24 24";
  }
  return "0 0 24 24";
});

const iconComponent = computed(() => {
  const iconDef = iconDefinitions[props.name as keyof typeof iconDefinitions];
  if (!iconDef) {
    console.warn(`BaseIcon "${props.name}" not found`);
    return null;
  }

  return defineComponent({
    render: () => iconDef(),
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: viewBox.value,
    class: _normalizeClass(['icon', `icon-${__props.name}`, __props.className]),
    "aria-label": __props.ariaLabel,
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    fill: ['google-drive', 'edit'].includes(__props.name) ? 'currentColor' : 'none',
    stroke: ['google-drive', 'edit'].includes(__props.name) ? 'none' : 'currentColor',
    "stroke-width": ['google-drive', 'edit'].includes(__props.name) ? '0' : '2',
    "stroke-linecap": ['google-drive', 'edit'].includes(__props.name) ? 'none' : 'round',
    "stroke-linejoin": 
      ['google-drive', 'edit'].includes(__props.name) ? 'none' : 'round'
    
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponent.value)))
  ], 10, _hoisted_1))
}
}

})